(function() {
  var section = document.querySelector('[data-ghost-faq]');
  if (!section) return;

  var categoryToggles = section.querySelectorAll('[data-faq-category-toggle]');
  var questionToggles = section.querySelectorAll('[data-faq-question-toggle]');

  function closeAllCategories(exceptPanel) {
    section.querySelectorAll('[data-faq-category-panel]').forEach(function(panel) {
      if (panel === exceptPanel) return;
      panel.hidden = true;
      panel.classList.remove('is-open');
    });

    categoryToggles.forEach(function(toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? section.querySelector('#' + panelId) : null;
      var isOpen = panel && panel === exceptPanel;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.parentElement.classList.toggle('is-open', isOpen);
    });
  }

  function closeAllQuestions(exceptPanel) {
    section.querySelectorAll('[data-faq-question-panel]').forEach(function(panel) {
      if (panel === exceptPanel) return;
      panel.hidden = true;
      panel.classList.remove('is-open');
    });

    questionToggles.forEach(function(toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? section.querySelector('#' + panelId) : null;
      var isOpen = panel && panel === exceptPanel;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  categoryToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? section.querySelector('#' + panelId) : null;
      if (!panel) return;

      var willOpen = panel.hidden;
      closeAllCategories(willOpen ? panel : null);

      panel.hidden = !willOpen;
      panel.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggle.closest('[data-faq-category]').classList.toggle('is-open', willOpen);
    });
  });

  questionToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
      event.stopPropagation();

      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? section.querySelector('#' + panelId) : null;
      if (!panel) return;

      var willOpen = panel.hidden;
      closeAllQuestions(willOpen ? panel : null);

      panel.hidden = !willOpen;
      panel.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });
})();
